import { css, cx } from "@emotion/css";
import { text, themeTokens, space } from "@octopusdeploy/design-system-tokens";
import type { ReactElement } from "react";
import * as React from "react";
import { useMediaQuery } from "react-responsive";
interface EmptyPageProps {
    image: ReactElement;
    title: string;
    description: string;
    action?: ReactElement;
    isCompact?: boolean;
}
export function EmptyPage({ image, title, description, action, isCompact }: EmptyPageProps) {
    const isLargerThanIpad = useMediaQuery({ query: `(min-width: 811px)` });
    return (<div className={cx(emptyPageStyles, { [emptyPageMobileStyles]: !isLargerThanIpad })}>
            {image}
            <div className={cx(contentStyles, { [contentStylesMedium]: isCompact })}>
                <h2 className={cx(headerStyles, { [headerStylesMedium]: isCompact })}>{title}</h2>
                <div className={descriptionStyles}>{description}</div>
                {action}
            </div>
        </div>);
}
const emptyPageStyles = css({
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    paddingTop: "10rem",
    gap: space[16],
});
const emptyPageMobileStyles = css({
    padding: space[24],
});
const contentStyles = css({
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    gap: space[8],
    font: text.body.regular.large,
    color: themeTokens.color.text.secondary,
});
const headerStylesMedium = css({
    font: text.heading.medium,
});
const contentStylesMedium = css({
    font: text.body.regular.medium,
});
const headerStyles = css({
    all: "unset",
    font: text.heading.large,
    color: themeTokens.color.text.primary,
});
const descriptionStyles = css({
    maxWidth: "42.25rem",
    textAlign: "center",
});
